import { BaseHmComponent } from './../base-hm/base-hm.component';
import { OnInit, Input, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { Location } from '@angular/common';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NbToastrService } from '@nebular/theme';


@Component({
    selector: 'app-edit-component',
    styleUrls: ['./edit.component.scss'],
    templateUrl: './edit.component.html',
})

export class EditComponent extends BaseHmComponent implements OnInit {

    protected validators = {};
    @Input() item: any;

    populateForms() {

    }

    constructor(
        protected route: ActivatedRoute,
        protected hmService: HappyMammaService,
        protected location: Location,
        private ms: NgbModal,
        protected toastrService: NbToastrService,
    ) {
        super(hmService, toastrService);
    }

    async ngOnInit() {
        await this.fetchDependencies();
        this.populateForms();
    }

    async fetchDependencies() {

    }

    openConfirmPopup(
        modalHeader: string,
        modalContent: string,
        modalOkButton: string,
        modalCancelButton: string,
        modalCancelEnabled: boolean = true,
        clickOutsideEnabled: boolean = true,
    ) {
        let backdrop: any;
        if (clickOutsideEnabled) {
            backdrop = true;
        } else {
            backdrop = 'static';
        }
        const activeModal = this.ms.open(AlertModalComponent, {
            size: 'sm',
            container: 'nb-layout',
            backdrop: backdrop,
        });
        activeModal.componentInstance.modalHeader = modalHeader;
        activeModal.componentInstance.modalContent = modalContent;

        activeModal.componentInstance.modalOkText = modalOkButton;
        if (modalCancelEnabled) {
            activeModal.componentInstance.modalCancelText = modalCancelButton;
            activeModal.componentInstance.modalCancelEnabled = modalCancelEnabled;
        }
        activeModal.componentInstance.action.subscribe(okButtonPressed => {
            if (okButtonPressed) {
                this.onPopupConfirm();
                activeModal.componentInstance.action.unsubscribe();
            }
        });

        return activeModal;
    }

    onPopupConfirm() { }

    myActions = {
        save: property => {
            alert(JSON.stringify(property.value));
            this.doSave(property);
        },
        reset: property => {
            property.reset();
        },
        cancel: this.goBack,
    };

    doSave(form): void { }

    onFormChange(event) {
        if (this.item) Object.assign(this.item, event.value);
    }

    goBack(): void {
        this.location.back();
    }

    generateLocalizationFieldset = function (items: [{}]) {
        return {
            type: 'fieldset',
            items: this.generateLocalizationTabs(items),
        };
    };

}
